import { render, staticRenderFns } from "./WidgetFoldButton.vue?vue&type=template&id=3b9a7d85"
import script from "./WidgetFoldButton.vue?vue&type=script&lang=js"
export * from "./WidgetFoldButton.vue?vue&type=script&lang=js"
import style0 from "./WidgetFoldButton.vue?vue&type=style&index=0&id=3b9a7d85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports